import React from 'react';

import Localization from "composer/Localization.jsx"

// development variables begin

const UNIT_TEST = false;


const DEBUG = false;

const DEBUG_AUTO_ENTER_LOCALE = false;

const DEBUG_ID = 0;
// development variables end (remove later)

// Google Custom Search Engine ID
const CSE_ID = "011803233796410265963:n7hp-9twnda";

// Google Custom Search Engine API key
const CSE_API_KEY = "AIzaSyD4R7a5wKz5A95h1VwkGSTXoViI6Ji5k2s";

// CHANGE before deployment  **************
const HOST_URL = "https://vrhost.ev-cuhk.net/~evvr/";

const MD5_KILL_SALT = "QaZ468pLm";

const AGREEMENT_URL = "https://ev-cuhk.net/agreement/evvr_current_version.html";

class Config extends React.Component {
  // development functions begin

  static IS_UNIT_TEST(){
    return UNIT_TEST;
  }

  static IS_DEBUG() {
    return DEBUG;
  }

  static IS_DEBUG_AUTO_ENTER_LOCALE() {
    return DEBUG_AUTO_ENTER_LOCALE;
  }

  static DEBUG_LOCALE() {
    return DEBUG_ID;
  }
  // development functions end

  static HOST_URL() {
    return HOST_URL;
  }

  static CLIENT_PATH() {
    return HOST_URL + 'client_v2/';
  }

  static CSE_ID() {
    return CSE_ID;
  }

  static CSE_API_KEY() {
    return CSE_API_KEY;
  }

 // CHANGE before deployment  **************
  static API_PATH() {
    if (Config.IS_DEBUG() === true) {
      return HOST_URL + 'api_t/';
    }
    else {
      return HOST_URL + 'api_v2_20240321_s/';
      // return HOST_URL + 'api_v2_20240207_s/'; for azure blob
    }
  }

// CHANGE before deployment  **************
  static BASE_PATH() {
    return HOST_URL + 'uploads/';
    // return 'https://evvrblob.blob.core.windows.net/evvr-uploads/'; for azure blob
  }

  static UPLOAD_PATH() {
    return Config.API_PATH() + 'upload.php';
  }

  static GET_MD5_KILL_SALT(){
    return MD5_KILL_SALT;
  }

  static AGREEMENT_URL() {
    return AGREEMENT_URL;
  }

  static GET_PLAYBACK_CONFIG(index) {

    var playbackData = [
      {
        // 0
        name:"Empty",
        name_short: "Em",
        icon: "",
        shouldPauseVideo: 0,
        hasPosition: false,
        description: "",
      },
      {
        // 1
        name: Localization.strings.ELEMENT_TYPE_TAG,
        name_short: Localization.strings.ELEMENT_TYPE_TAG,
        icon: "label",
        shouldPauseVideo: 0,
        hasPosition: true,
        description: Localization.strings.ELEMENT_DESCRIPTION_TAG,
      },
      {
        // 2
        name: Localization.strings.ELEMENT_TYPE_MC,
        name_short: Localization.strings.ELEMENT_TYPE_MC,
        icon: "view_list",
        shouldPauseVideo: 1,
        hasPosition: false,
        description: Localization.strings.ELEMENT_DESCRIPTION_MC,
      },
      {
        // 3
        name: Localization.strings.ELEMENT_TYPE_PORTAL,
        name_short: Localization.strings.ELEMENT_TYPE_PORTAL,
        icon: "directions_run",
        shouldPauseVideo: 1,
        hasPosition: false,
        description: Localization.strings.ELEMENT_DESCRIPTION_PORTAL,
      },
      {
        // 4
        name: Localization.strings.ELEMENT_TYPE_VOICE_ANSWER,
        name_short: "Voice Ans",
        icon: "mic",
        shouldPauseVideo: 1,
        hasPosition: true,
        description: Localization.strings.ELEMENT_DESCRIPTION_VOICE_ANSWER,
      },
      {
        // 5
        name: Localization.strings.ELEMENT_TYPE_TREASURE,
        name_short: Localization.strings.ELEMENT_TYPE_TREASURE,
        icon: "explore",
        shouldPauseVideo: 0,
        hasPosition: true,
        description: Localization.strings.ELEMENT_DESCRIPTION_TREASURE,
      },
      {
        // 6
        name: Localization.strings.ELEMENT_TYPE_TELEPORT,
        name_short: Localization.strings.ELEMENT_TYPE_TELEPORT,
        icon: "location_on",
        shouldPauseVideo: 0,
        hasPosition: true,
        description: Localization.strings.ELEMENT_DESCRIPTION_TELEPORT,
      }
      // {name:"Question(Text)",   name_short: "Text Q",  	icon: "", 							shouldPauseVideo: 1,},   // 4
      // {name:"Question(Voice)",  name_short: "Voice Q",  icon: "", 							shouldPauseVideo: 1,},   // 5
      // {name:"Voice Clip",       name_short: "Voice",  	icon: "", 							shouldPauseVideo: 0,},   // 6
      // {name:"Enlarged Image",   name_short: "Big Pic",  icon: "", 							shouldPauseVideo: 0,},   // 7
    ];

    // return the list (for counting length or other purpose)
    // if the index passed is null
    if (index == null) {
      return playbackData;
    }
    else {
      return playbackData[index];
    }
  }

  static GET_INTERACTION_KIND(index){
    var interactionData = {
      "1": "Tag: OPEN",
      "2": "Tag: CLOSE",
      "11": "Voice Over: PLAY AUDIO",
      "12": "Voice Over: PAUSE AUDIO",
      "13": "Voice Over: REPLAY AUDIO",
      "14": "Voice Over: RESUME AUDIO",
      "21": "Multiple Choices: ANSWERED CORRECTLY",
      "22": "Multiple Choices: ANSWERED WRONGLY",
      "31": "Portal: ENTER",
      "41": "Voice Question: START RECORDING",
      "42": "Voice Question: STOP RECORDING",
      "43": "Voice Question: REPLAY RECORD",
      "44": "Voice Question: STOP REPLAYING RECORD",
      "45": "Voice Question: DELETE RECORD",
      "46": "Voice Question: SAVE RECORD",
      "51": "Treasure: FOUND",
      "61": "Teleport: ENTER",
    }

    if (index == null) {
      return interactionData;
    }
    else {
      return interactionData[index];
    }
  }

  static GET_MANIPULATION_KIND(index){
    var manipulationData = {
      "101": "Control Panel: OPEN",
      "102": "Control Panel: CLOSE",
      "103": "Control Panel: PLAY",
      "104": "Control Panel: PAUSE",
      "105": "Control Panel: RESTART",
      "106": "Control Panel: STAGE SELECTION",
      "107": "Control Panel: UNLOCK STAGES",
      "108": "Control Panel: BACK",
      "109": "Control Panel: TO GOGGLES MODE",
    };

    if (index == null) {
      return manipulationData;
    }
    else {
      return manipulationData[index];
    }
  }

  static GET_ALLOWED_FILE_EXTENSION(type) {
    if (type == "video") {
      return "mov,mp4,m4v,avi";
    }
    else if (type == "image") {
      return "jpg,jpeg,png";
    }
    else if (type == "audio") {
      return "mp3";
    }
    else {
      return "";
    }
  }
}

export default Config;
